import { TieredMenu } from "primereact/tieredmenu";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sideBarItems = useMemo(
    () => [
      {
        label: "Учебни планове",
        icon: "pi pi-list",
        command: () => {
          navigate("/plans");
        },
        className: pathname === "/plans" ? "p-focus" : "",
      },
      {
        label: "Протоколи",
        icon: "pi pi-file",
        command: () => {
          navigate("/protocols");
        },
      },
      {
        label: "Учебно разписание",
        icon: "pi pi-calendar-clock",
        command: () => {
          navigate("/schedule");
        },
      },
      {
        label: "Справки",
        icon: "pi pi-receipt",
        items: [
          {
            label: "Справка 1",
          },
          {
            label: "Справка 2",
          },
        ],
      },
    ],
    [pathname],
  );

  return <TieredMenu model={sideBarItems} breakpoint="767px" className="w-full" />;
};

export default Sidebar;
